module.exports = __webpack_public_path__ + "img/img_statement_clearance_receipt.0d24218f.png";